import React, { Fragment } from "react"
import ReactDOM from "react-dom"
import { Box, List, ListItem, Typography, Link } from "@material-ui/core"
import Button from "../../CustomButtons/Button"
import { makeStyles } from "@material-ui/core/styles"
import { Avatar } from "@material-ui/core"
import NewsImage from "../../../assets/images/new-list-img.png"
const useStyles = makeStyles(theme => ({
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}))
const NewsItem = ({ data }) => {
  const classes = useStyles()
  const StrippedString =
    data["body"].replace(/(<([^>]+)>)/gi, "").slice(0, 230) + "..."
  return (
    <Fragment>
      <ListItem className={classes.listItem + " " + "items"}>
        <Box component="div" className="mez thumb-block">
          <figure>
            <Link href="#">
              <img
                src={data["imageUrl"]}
                alt=""
                title=""
                height="240"
                width="320"
                className="img-responsive full-width"
              />
            </Link>
          </figure>
          <Box component="div" className="thumb-block__detail">
            <Box component="div" className="thumb-block__wrap">
              <Typography variant="h2">
                <Link href="#">{data["title"]}</Link>
              </Typography>
              <Box component="span">{data["date"]}</Box>
              <Typography variant="body2">{StrippedString}</Typography>
            </Box>
            <Button
              type="submit"
              variant="contained"
              color="blue"
              className={classes.submit}
            >
              Read More
            </Button>
          </Box>
        </Box>
      </ListItem>
    </Fragment>
  )
}

export default NewsItem
